<ion-content>
  <div class="d-flex flex-column align-items-center justify-content-center h-100 px-4 text-center voice-dialog-container">
    <div class="voice-title mb-4">
      {{ "VOICE_RECOGNITION.TITLE" | translate }}
    </div>
    <div class="voice-icon-container">
      <button class="btn recording" type="button" (click)="this.close()" *ngIf="!this.isClosing">
        <mat-icon class="voice-icon" svgIcon="farMicrophoneCircle"></mat-icon>
      </button>
      <ng-lottie [options]="successBlueAnimation" width="130px" height="130px" *ngIf="this.isClosing" (animationCreated)="onAnimationCreated($event)" />
    </div>

    <div class="d-inline-flex gap h-6 mt-3 overflow-hidden flex-wrap mx-2" *ngIf="!this.isClosing">
      <div class="d-inline-flex align-items-center h-full" *ngFor="let rms of visualizerData; let i = index; trackBy: trackByIndex">
        <div class="w2 flex-shrink-0 waveform-bar inline-block" [ngStyle]="getWaveform(rms)"></div>
      </div>
    </div>

    <div class="mt-1" *ngIf="!this.isClosing">
      <div class="voice-preview">
        {{ this.message }}
      </div>
      <div class="voice-preview" *ngIf="this.message.length == 0">
        {{ "VOICE_RECOGNITION.INSTRUCTION" | translate }}
      </div>
    </div>

  </div>
</ion-content>